[
  {
    "prompt": "Appear nervous",
    "incorrect": "People will notice my anxiety.",
    "correct": "No one else notices my nerves."
  },
  {
    "prompt": "Mind wandering",
    "incorrect": "I might be losing control of my mind.",
    "correct": "My imagination is very active."
  },
  {
    "prompt": "Scared",
    "incorrect": "My heart’s beating too fast.",
    "correct": "I’m watching a scary movie."
  },
  {
    "prompt": "Nauseous",
    "incorrect": "I might be really sick.",
    "correct": "This feeling will pass soon."
  },
  {
    "prompt": "Distracted",
    "incorrect": "Something bad is happening in my mind.",
    "correct": "I’m just thinking of exciting things."
  },
  {
    "prompt": "Trembling",
    "incorrect": "People see that I’m anxious.",
    "correct": "I rarely notice others trembling."
  },
  {
    "prompt": "Chest tight",
    "incorrect": "I might not be able to breathe.",
    "correct": "Tight chest happens and passes."
  },
  {
    "prompt": "Beating rapidly",
    "incorrect": "I’m having a heart attack.",
    "correct": "A fast heart feels good after exercise."
  },
  {
    "prompt": "Judged",
    "incorrect": "People think I’m acting strangely.",
    "correct": "Nervousness is rarely noticed by others."
  },
  {
    "prompt": "Chest pain",
    "incorrect": "This must be a heart attack.",
    "correct": "Indigestion is likely the cause."
  },
  {
    "prompt": "Spacey",
    "incorrect": "I’m losing my mind.",
    "correct": "I just blew up a party balloon."
  },
  {
    "prompt": "Going crazy",
    "incorrect": "I can’t focus on anything.",
    "correct": "Most people feel this at times."
  },
  {
    "prompt": "Shaky",
    "incorrect": "I might be having a seizure.",
    "correct": "Shaky means I’m excited for the date."
  },
  {
    "prompt": "Light headed",
    "incorrect": "I could have an aneurysm.",
    "correct": "Light-headedness is normal."
  },
  {
    "prompt": "Important",
    "incorrect": "I must control my emotions now.",
    "correct": "I don’t let anxiety control me."
  },
  {
    "prompt": "Stomach pain",
    "incorrect": "Something’s terribly wrong inside.",
    "correct": "An antacid will help my stomach."
  },
  {
    "prompt": "Heart",
    "incorrect": "Fast heartbeat is something bad.",
    "correct": "My heart feels good after exercise."
  },
  {
    "prompt": "Headache",
    "incorrect": "It could be a brain tumor.",
    "correct": "Stress from school causes headaches."
  },
  {
    "prompt": "People laugh",
    "incorrect": "I embarrassed myself.",
    "correct": "I told a funny joke, that’s all."
  },
  {
    "prompt": "Yawn",
    "incorrect": "People are bored with me.",
    "correct": "My friend didn’t sleep well last night."
  },
  {
    "prompt": "Sweating",
    "incorrect": "Sweating means everyone will notice.",
    "correct": "I’m warm; sweating is normal."
  },
  {
    "prompt": "Breathing fast",
    "incorrect": "I’ll faint from hyperventilating.",
    "correct": "Breathing fast means I’m active."
  },
  {
    "prompt": "Red cheeks",
    "incorrect": "Everyone sees my embarrassment.",
    "correct": "Red cheeks show excitement."
  },
  {
    "prompt": "Closed-in space",
    "incorrect": "I’ll be trapped and can’t escape.",
    "correct": "Small spaces can feel cozy."
  },
  {
    "prompt": "Unfamiliar faces",
    "incorrect": "They’ll judge and reject me.",
    "correct": "New people could lead to friendships."
  },
  {
    "prompt": "Sweaty palms",
    "incorrect": "People will notice my sweaty hands.",
    "correct": "Sweaty hands are just natural."
  },
  {
    "prompt": "Dry mouth",
    "incorrect": "Dry mouth shows my fear.",
    "correct": "I’ll just sip some water."
  },
  {
    "prompt": "Darkness",
    "incorrect": "Something bad might lurk in darkness.",
    "correct": "Darkness feels peaceful to me."
  },
  {
    "prompt": "Alarm sound",
    "incorrect": "The alarm means something’s wrong.",
    "correct": "Alarms are just reminders."
  },
  {
    "prompt": "Blood pressure",
    "incorrect": "High blood pressure is dangerous.",
    "correct": "BP changes are normal."
  },
  {
    "prompt": "Missed call",
    "incorrect": "They’ll be upset I missed it.",
    "correct": "I’ll call them back soon."
  },
  {
    "prompt": "Exam",
    "incorrect": "Failing will ruin everything.",
    "correct": "Exams help me learn."
  },
  {
    "prompt": "News headline",
    "incorrect": "Headlines prove the world is dangerous.",
    "correct": "Headlines are just attention-grabbers."
  },
  {
    "prompt": "Waiting room",
    "incorrect": "I’ll get bad news here.",
    "correct": "Waiting rooms are just for sitting."
  },
  {
    "prompt": "Coughing",
    "incorrect": "This might be something serious.",
    "correct": "Coughing just clears my throat."
  },
  {
    "prompt": "Walking alone",
    "incorrect": "Someone could follow and harm me.",
    "correct": "Walking alone clears my mind."
  },
  {
    "prompt": "Loud noise",
    "incorrect": "Noise means danger is nearby.",
    "correct": "Loud sounds happen all the time."
  },
  {
    "prompt": "Silence",
    "incorrect": "Silence means danger is close.",
    "correct": "Silence lets me relax and think."
  },
  {
    "prompt": "Large crowd",
    "incorrect": "I could feel trapped or lost.",
    "correct": "Crowds have interesting people."
  },
  {
    "prompt": "Eye contact",
    "incorrect": "They’ll see what’s wrong with me.",
    "correct": "Eye contact shows confidence."
  },
  {
    "prompt": "Feeling shaky",
    "incorrect": "Shaking means I’ll collapse soon.",
    "correct": "Shaking means I need rest."
  },
  {
    "prompt": "Taking a break",
    "incorrect": "Stopping means I’ll fall behind.",
    "correct": "Breaks make me more refreshed."
  },
  {
    "prompt": "Getting feedback",
    "incorrect": "They’ll point out my flaws.",
    "correct": "Feedback will help me improve."
  },
  {
    "prompt": "Spinning room",
    "incorrect": "I’ll faint or fall.",
    "correct": "Spinning just means I’m tired."
  },
  {
    "prompt": "Fast heartbeat",
    "incorrect": "My heart could stop suddenly.",
    "correct": "A fast heart means excitement."
  },
  {
    "prompt": "Blurry vision",
    "incorrect": "This must mean something bad.",
    "correct": "Vision blurs when I’m tired."
  },
  {
    "prompt": "Shortness of breath",
    "incorrect": "I’m losing my breath entirely.",
    "correct": "Deep breaths relax me."
  },
  {
    "prompt": "Weak feeling",
    "incorrect": "My body might be shutting down.",
    "correct": "Weakness means I need food or rest."
  },
  {
    "prompt": "Being alone",
    "incorrect": "No one will help if I need it.",
    "correct": "Alone time recharges me."
  },
  {
    "prompt": "Feeling dizzy",
    "incorrect": "I’ll faint and embarrass myself.",
    "correct": "Dizzy spells happen when I’m tired."
  },
  {
    "prompt": "Heart racing",
    "incorrect": "My heart feels out of control.",
    "correct": "I must be excited about something."
  },
  {
    "prompt": "Breath quickening",
    "incorrect": "I'm having trouble breathing.",
    "correct": "I must have walked faster than usual."
  },
  {
    "prompt": "Feeling tense",
    "incorrect": "I’m getting really anxious.",
    "correct": "I just need to take a quick break."
  },
  {
    "prompt": "Jittery hands",
    "incorrect": "Everyone will notice my shaking.",
    "correct": "It’s just a bit of extra energy."
  },
  {
    "prompt": "Forgetfulness",
    "incorrect": "What if I’m losing my memory?",
    "correct": "It’s normal to forget small details."
  },
  {
    "prompt": "Sweaty palms",
    "incorrect": "People might think I’m scared.",
    "correct": "I just need to cool off a bit."
  },
  {
    "prompt": "Unfamiliar place",
    "incorrect": "I could get lost or stuck here.",
    "correct": "Exploring new places can be fun."
  },
  {
    "prompt": "Thoughts racing",
    "incorrect": "I can’t seem to slow my mind down.",
    "correct": "I’m just full of new ideas."
  },
  {
    "prompt": "Looking away",
    "incorrect": "People will think I'm hiding something.",
    "correct": "I'm just enjoying the surroundings."
  },
  {
    "prompt": "Feeling dizzy",
    "incorrect": "I might faint or fall.",
    "correct": "Maybe I just need some water."
  },
  {
    "prompt": "Hearing noises",
    "incorrect": "What if someone’s watching me?",
    "correct": "It’s just the house settling."
  },
  {
    "prompt": "New environment",
    "incorrect": "I don’t know what’s safe here.",
    "correct": "It’s a chance to learn new things."
  },
  {
    "prompt": "Feeling warm",
    "incorrect": "I might be getting sick.",
    "correct": "Maybe it’s just the weather."
  },
  {
    "prompt": "Hard to focus",
    "incorrect": "I can’t seem to stay in control.",
    "correct": "My mind is just wandering today."
  },
  {
    "prompt": "Quiet voices",
    "incorrect": "They must be talking about me.",
    "correct": "They’re probably just chatting."
  },
  {
    "prompt": "Unsteady walking",
    "incorrect": "I might fall or stumble.",
    "correct": "My legs just need a stretch."
  },
  {
    "prompt": "Looking nervous",
    "incorrect": "Everyone must notice my anxiety.",
    "correct": "People are focused on their own things."
  },
  {
    "prompt": "Feeling tense",
    "incorrect": "I can't relax, something must be wrong.",
    "correct": "I just need to unwind a bit."
  },
  {
    "prompt": "Seeing strangers",
    "incorrect": "They might be dangerous.",
    "correct": "They're just busy with their day."
  },
  {
    "prompt": "Fidgeting",
    "incorrect": "People might think I'm strange.",
    "correct": "I just need to move around a bit."
  },
  {
    "prompt": "Random pains",
    "incorrect": "This could be a serious health issue.",
    "correct": "It’s probably just temporary."
  },
  {
    "prompt": "Loss of appetite",
    "incorrect": "There’s something wrong with me.",
    "correct": "It could just be stress."
  },
  {
    "prompt": "Public speaking",
    "incorrect": "Everyone will notice if I mess up.",
    "correct": "Everyone makes small mistakes."
  },
  {
    "prompt": "Crowded room",
    "incorrect": "It’s too overwhelming, I might panic.",
    "correct": "I see many interesting people here."
  },
  {
    "prompt": "Quiet room",
    "incorrect": "They’re all silently judging me.",
    "correct": "Everyone’s just relaxed and quiet."
  },
  {
    "prompt": "Uncertain plans",
    "incorrect": "This could go badly if I’m not prepared.",
    "correct": "It’ll work out one way or another."
  },
  {
    "prompt": "Feeling weak",
    "incorrect": "Something’s wrong with my health.",
    "correct": "I probably just need some rest."
  },
  {
    "prompt": "Worried about time",
    "incorrect": "I’m late; this could ruin my plans.",
    "correct": "I can manage my time as I go."
  },
  {
    "prompt": "Feeling isolated",
    "incorrect": "No one wants to be around me.",
    "correct": "Sometimes it’s nice to have alone time."
  },
  {
    "prompt": "Feeling vulnerable",
    "incorrect": "Something bad could happen to me.",
    "correct": "It’s okay to be open sometimes."
  },
  {
    "prompt": "Unfamiliar faces",
    "incorrect": "I don’t know if I can trust them.",
    "correct": "It’s a chance to meet new people."
  },
  {
    "prompt": "Dark rooms",
    "incorrect": "Someone might be hiding there.",
    "correct": "It’s just a bit dim, that’s all."
  },
  {
    "prompt": "Loud noises",
    "incorrect": "Something bad could be happening.",
    "correct": "It’s just the city sounds."
  },
  {
    "prompt": "Getting tired",
    "incorrect": "I’m losing all my energy.",
    "correct": "I probably just need to rest."
  },
  {
    "prompt": "Remembering past events",
    "incorrect": "That mistake still defines me.",
    "correct": "It's just a memory, it doesn’t control me."
  },
  {
    "prompt": "Trying something new",
    "incorrect": "I could fail and look foolish.",
    "correct": "It’s an opportunity to learn."
  },
  {
    "prompt": "Meeting deadlines",
    "incorrect": "I might not be able to finish on time.",
    "correct": "I can manage my tasks step by step."
  },
  {
    "prompt": "Feeling on edge",
    "incorrect": "Something terrible might happen.",
    "correct": "Maybe I just need a break."
  },
  {
    "prompt": "Checking surroundings",
    "incorrect": "There could be hidden dangers.",
    "correct": "It’s good to be aware of my environment."
  },
  {
    "prompt": "Unfamiliar noise",
    "incorrect": "Someone might be trying to break in.",
    "correct": "It’s likely just the wind or an animal."
  },
  {
    "prompt": "Not understanding",
    "incorrect": "People will think I’m not smart.",
    "correct": "Everyone learns at their own pace."
  },
  {
    "prompt": "Close proximity to others",
    "incorrect": "They’re watching and judging me.",
    "correct": "People are just around, doing their thing."
  },
  {
    "prompt": "Loss of direction",
    "incorrect": "I’ll never find my way back.",
    "correct": "I can ask for directions if needed."
  },
  {
    "prompt": "Being alone at night",
    "incorrect": "What if something dangerous happens?",
    "correct": "It’s peaceful to have quiet time."
  },
  {
    "prompt": "Forgetting a name",
    "incorrect": "They’ll think I’m rude.",
    "correct": "It happens to everyone."
  },
  {
    "prompt": "Sweating unexpectedly",
    "incorrect": "What if they notice and judge me?",
    "correct": "Maybe I just need to cool down."
  },
  {
    "prompt": "Unfamiliar place",
    "incorrect": "I could get lost and no one will help.",
    "correct": "I’m just exploring a new area."
  },
  {
    "prompt": "In a quiet group",
    "incorrect": "Everyone’s waiting for me to mess up.",
    "correct": "People are just enjoying the quiet."
  },
  {
    "prompt": "Social gathering",
    "incorrect": "What if no one wants to talk to me?",
    "correct": "Everyone is here to have a good time."
  },
  {
    "prompt": "Time moving quickly",
    "incorrect": "I’m losing control of everything.",
    "correct": "Time flies when you’re busy."
  },
  {
    "prompt": "Unexpected silence",
    "incorrect": "Everyone is silently judging me.",
    "correct": "It’s just a peaceful moment."
  },
  {
    "prompt": "Busy schedule",
    "incorrect": "I won’t manage everything on time.",
    "correct": "I’ll handle things one step at a time."
  },
  {
    "prompt": "Unfamiliar food",
    "incorrect": "What if I get sick from eating this?",
    "correct": "It’s a chance to try something new."
  },
  {
    "prompt": "Missed call",
    "incorrect": "It might be bad news I missed.",
    "correct": "I can call them back when I’m ready."
  },
  {
    "prompt": "No response",
    "incorrect": "They must be ignoring me.",
    "correct": "They’re probably just busy right now."
  },
  {
    "prompt": "Hard to remember",
    "incorrect": "I’m forgetting important things.",
    "correct": "Forgetting details happens to everyone."
  },
  {
    "prompt": "In a hurry",
    "incorrect": "I’m going to make a mistake.",
    "correct": "I can still focus even when I’m fast."
  },
  {
    "prompt": "Loud laughter",
    "incorrect": "They must be laughing at me.",
    "correct": "They’re just having a good time."
  },
  {
    "prompt": "Low energy",
    "incorrect": "Something must be wrong with me.",
    "correct": "I probably just need some rest."
  },
  {
    "prompt": "Early morning",
    "incorrect": "I’m not ready to start the day.",
    "correct": "It’s a fresh start to the day."
  },
  {
    "prompt": "Sudden change",
    "incorrect": "I won’t be able to adjust.",
    "correct": "Change is part of life; I’ll adapt."
  },
  {
    "prompt": "New task",
    "incorrect": "What if I mess this up?",
    "correct": "This is a chance to learn."
  },
  {
    "prompt": "Unexpected noise",
    "incorrect": "Something bad is happening.",
    "correct": "It’s just the sounds of the environment."
  },
  {
    "prompt": "Busy environment",
    "incorrect": "It’s overwhelming; I’ll panic.",
    "correct": "Busy places can be energizing."
  },
  {
    "prompt": "Traveling alone",
    "incorrect": "Something might happen to me.",
    "correct": "It’s a chance to explore on my own."
  },
  {
    "prompt": "Losing focus",
    "incorrect": "I’m losing control of my mind.",
    "correct": "It’s natural to daydream sometimes."
  },
  {
    "prompt": "Feeling heavy",
    "incorrect": "Something is weighing me down.",
    "correct": "I might just need a short rest."
  },
  {
    "prompt": "Unplanned event",
    "incorrect": "I won’t know what to do.",
    "correct": "I can handle surprises as they come."
  },
  {
    "prompt": "Crowded street",
    "incorrect": "I’m going to feel trapped.",
    "correct": "It’s lively to see so many people."
  },
  {
    "prompt": "Quiet surroundings",
    "incorrect": "Everyone’s listening to my every move.",
    "correct": "It’s peaceful and calm here."
  },
  {
    "prompt": "Confusing instructions",
    "incorrect": "I won’t be able to follow along.",
    "correct": "I can take my time to understand."
  },
  {
    "prompt": "Speaking up",
    "incorrect": "People might think I’m wrong.",
    "correct": "It’s good to share my ideas."
  },
  {
    "prompt": "Blank mind",
    "incorrect": "I’m forgetting everything important.",
    "correct": "It’s okay to take a moment to think."
  },
  {
    "prompt": "Busy city",
    "incorrect": "It’s too chaotic, I’ll panic.",
    "correct": "Cities are full of interesting things."
  },
  {
    "prompt": "Random memory",
    "incorrect": "It’s a sign something’s wrong.",
    "correct": "It’s just a passing thought."
  },
  {
    "prompt": "Out of control",
    "incorrect": "I can’t manage anything right now.",
    "correct": "I can break things down step by step."
  },
  {
    "prompt": "Unexpected crowd",
    "incorrect": "I’ll feel trapped in the crowd.",
    "correct": "I’ll navigate through at my own pace."
  },
  {
    "prompt": "Delayed reply",
    "incorrect": "They must be upset with me.",
    "correct": "People take time to respond sometimes."
  },
  {
    "prompt": "Being watched",
    "incorrect": "They’re judging my every move.",
    "correct": "People are just glancing around."
  },
  {
    "prompt": "Out of breath",
    "incorrect": "I can't catch my breath.",
    "correct": "I probably just need to slow down."
  },
  {
    "prompt": "Shaking hands",
    "incorrect": "Everyone will see how nervous I am.",
    "correct": "My hands are just a bit restless."
  },
  {
    "prompt": "Feeling disconnected",
    "incorrect": "I’m losing touch with reality.",
    "correct": "It’s just a momentary feeling."
  },
  {
    "prompt": "Paused conversation",
    "incorrect": "They’re thinking poorly of me.",
    "correct": "Sometimes conversations have pauses."
  },
  {
    "prompt": "Cold room",
    "incorrect": "I’ll feel uncomfortable here.",
    "correct": "I’ll warm up soon or adjust."
  },
  {
    "prompt": "Forgotten item",
    "incorrect": "It’ll ruin my whole plan.",
    "correct": "I can manage or find a substitute."
  },
  {
    "prompt": "Arriving late",
    "incorrect": "People will judge me for being late.",
    "correct": "Everyone’s been late at some point."
  },
  {
    "prompt": "Gaining attention",
    "incorrect": "They’re all noticing my flaws.",
    "correct": "People are just being friendly."
  },
  {
    "prompt": "Lost in thought",
    "incorrect": "I’m disconnecting from reality.",
    "correct": "It’s just a moment of reflection."
  },
  {
    "prompt": "Feeling restless",
    "incorrect": "I can’t calm down, something’s wrong.",
    "correct": "Maybe I just need to move a bit."
  },
  {
    "prompt": "Missing information",
    "incorrect": "I’ll never understand the full picture.",
    "correct": "I can catch up as I go."
  },
  {
    "prompt": "New environment",
    "incorrect": "I won’t feel comfortable here.",
    "correct": "It’s a chance to explore a new place."
  },
  {
    "prompt": "Trying to relax",
    "incorrect": "I won’t be able to calm down.",
    "correct": "Relaxation takes a bit of time."
  },
  {
    "prompt": "Bright lights",
    "incorrect": "It’ll overwhelm my senses.",
    "correct": "I can adjust to the brightness."
  },
  {
    "prompt": "Checking time",
    "incorrect": "I’m running out of time for everything.",
    "correct": "I have enough time to do this steadily."
  },
  {
    "prompt": "Background noise",
    "incorrect": "It’ll distract me from everything.",
    "correct": "It’s just a normal part of life."
  },
  {
    "prompt": "Hearing whispers",
    "incorrect": "They’re whispering about me.",
    "correct": "They’re probably talking about their own."
  },
  {
    "prompt": "Looking around",
    "incorrect": "People will think I’m lost.",
    "correct": "It's normal to take in surroundings."
  },
  {
    "prompt": "Unfamiliar faces",
    "incorrect": "I don’t belong here.",
    "correct": "There are new people to meet."
  },
  {
    "prompt": "Staying alone",
    "incorrect": "I’ll be isolated and lonely.",
    "correct": "It’s okay to have some time to myself."
  },
  {
    "prompt": "Quick heart rate",
    "incorrect": "My heart is beating too fast.",
    "correct": "It’s just from moving quickly."
  },
  {
    "prompt": "Feeling observed",
    "incorrect": "They’re watching me closely.",
    "correct": "They’re busy with their own tasks."
  },
  {
    "prompt": "Hesitant words",
    "incorrect": "I sound uncertain to everyone.",
    "correct": "Pauses make me sound thoughtful."
  },
  {
    "prompt": "Tense shoulders",
    "incorrect": "I’m getting overly stressed.",
    "correct": "I just need to relax my muscles."
  },
  {
    "prompt": "Unexpected cough",
    "incorrect": "Everyone will think I’m sick.",
    "correct": "It’s just a small tickle."
  },
  {
    "prompt": "Yawning a lot",
    "incorrect": "I’m too exhausted to focus.",
    "correct": "It’s just a long day."
  },
  {
    "prompt": "Glancing around",
    "incorrect": "They’ll think I’m nervous.",
    "correct": "I’m just checking my surroundings."
  },
  {
    "prompt": "Small mistake",
    "incorrect": "They’ll think I’m careless.",
    "correct": "Everyone makes small mistakes."
  },
  {
    "prompt": "New colleague",
    "incorrect": "What if they dislike me?",
    "correct": "They’re just another team member."
  },
  {
    "prompt": "Sudden loud noise",
    "incorrect": "Something bad is happening.",
    "correct": "It was just unexpected noise."
  },
  {
    "prompt": "Unsteady voice",
    "incorrect": "They’ll hear my nerves.",
    "correct": "A calm breath will help."
  },
  {
    "prompt": "Familiar faces",
    "incorrect": "They’re judging me silently.",
    "correct": "They’re just passing by."
  },
  {
    "prompt": "Trying a shortcut",
    "incorrect": "I might get lost.",
    "correct": "It’s fun to explore a bit."
  },
  {
    "prompt": "Paused typing",
    "incorrect": "I’m too slow at work.",
    "correct": "I’m just taking my time."
  },
  {
    "prompt": "Not feeling hungry",
    "incorrect": "Is something wrong with me?",
    "correct": "Appetite varies day to day."
  },
  {
    "prompt": "Small talk",
    "incorrect": "They think I’m awkward.",
    "correct": "We’re just chatting casually."
  },
  {
    "prompt": "Sending a message",
    "incorrect": "What if they misread it?",
    "correct": "Messages are just words."
  },
  {
    "prompt": "Checking watch",
    "incorrect": "I’m running out of time.",
    "correct": "It’s just timekeeping."
  },
  {
    "prompt": "Quickly tired",
    "incorrect": "I’m unfit or weak.",
    "correct": "I just need some rest."
  },
  {
    "prompt": "Feeling dizzy",
    "incorrect": "I might faint.",
    "correct": "I’ll steady myself."
  },
  {
    "prompt": "Distant sounds",
    "incorrect": "Something’s coming.",
    "correct": "Just city sounds."
  },
  {
    "prompt": "Bright lights",
    "incorrect": "They’re too intense.",
    "correct": "I can adjust to it."
  },
  {
    "prompt": "Not remembering",
    "incorrect": "I’m losing memory.",
    "correct": "It’s normal to forget sometimes."
  },
  {
    "prompt": "Feeling chills",
    "incorrect": "I might be unwell.",
    "correct": "I’ll get warmer soon."
  },
  {
    "prompt": "Messy desk",
    "incorrect": "I’m disorganized.",
    "correct": "I can clean it up later."
  },
  {
    "prompt": "Closed door",
    "incorrect": "They’re hiding from me.",
    "correct": "They’re just busy."
  },
  {
    "prompt": "Forgot something",
    "incorrect": "I’ll ruin everything.",
    "correct": "I can adapt without it."
  },
  {
    "prompt": "Slow reply",
    "incorrect": "They’re upset with me.",
    "correct": "They’re just busy."
  },
  {
    "prompt": "Nighttime alone",
    "incorrect": "I’m not safe here.",
    "correct": "I’ll enjoy the peace."
  },
  {
    "prompt": "Checking phone",
    "incorrect": "I seem impatient.",
    "correct": "I’m just staying connected."
  },
  {
    "prompt": "Quiet at work",
    "incorrect": "People don’t like me.",
    "correct": "Everyone’s focused."
  },
  {
    "prompt": "Missing out",
    "incorrect": "I’m left out.",
    "correct": "Everyone has their own time."
  },
  {
    "prompt": "Fidgeting fingers",
    "incorrect": "I’m too anxious.",
    "correct": "I just need to move a bit."
  },
  {
    "prompt": "Soft voice",
    "incorrect": "They can’t hear me.",
    "correct": "I’m speaking calmly."
  },
  {
    "prompt": "Forgot name",
    "incorrect": "They’ll think I’m rude.",
    "correct": "Everyone forgets sometimes."
  },
  {
    "prompt": "Long pause",
    "incorrect": "They think I’m clueless.",
    "correct": "I’m just thinking."
  },
  {
    "prompt": "In a rush",
    "incorrect": "I’ll make mistakes.",
    "correct": "I’m just moving fast."
  },
  {
    "prompt": "Lost keys",
    "incorrect": "I’m so forgetful.",
    "correct": "They’ll turn up soon."
  },
  {
    "prompt": "Worried look",
    "incorrect": "They’ll think I’m scared.",
    "correct": "I’m just focused."
  },
  {
    "prompt": "Sighing",
    "incorrect": "I seem frustrated.",
    "correct": "I’m just breathing out."
  },
  {
    "prompt": "Repeating myself",
    "incorrect": "I sound silly.",
    "correct": "Rephrasing is fine."
  },
  {
    "prompt": "Blank stare",
    "incorrect": "I look clueless.",
    "correct": "I’m just lost in thought."
  },
  {
    "prompt": "Skipping meal",
    "incorrect": "It’s unhealthy.",
    "correct": "I’ll eat later."
  },
  {
    "prompt": "New hobby",
    "incorrect": "I’ll be terrible.",
    "correct": "I’m learning."
  },
  {
    "prompt": "Cold air",
    "incorrect": "I’ll get sick.",
    "correct": "It’s refreshing."
  },
  {
    "prompt": "Crowded train",
    "incorrect": "I’ll feel trapped.",
    "correct": "I’m just commuting."
  },
  {
    "prompt": "Losing signal",
    "incorrect": "I’ll miss important news.",
    "correct": "It’ll reconnect soon."
  },
  {
    "prompt": "Silent phone",
    "incorrect": "No one cares to call.",
    "correct": "It’s peaceful."
  },
  {
    "prompt": "Quiet friends",
    "incorrect": "They’re ignoring me.",
    "correct": "They’re just busy."
  },
  {
    "prompt": "Alone at lunch",
    "incorrect": "I have no one to eat with.",
    "correct": "I can enjoy a quiet meal."
  },
  {
    "prompt": "Random thought",
    "incorrect": "I’m losing my focus.",
    "correct": "Just a passing thought."
  },
  {
    "prompt": "Blank screen",
    "incorrect": "I can’t think of anything.",
    "correct": "I just need a fresh idea."
  },
  {
    "prompt": "Busy hands",
    "incorrect": "I’m too fidgety.",
    "correct": "Just keeping my hands moving."
  },
  {
    "prompt": "Heavy eyes",
    "incorrect": "I’m too tired to function.",
    "correct": "I just need a little rest."
  },
  {
    "prompt": "Shaky voice",
    "incorrect": "They’ll hear my nerves.",
    "correct": "It’ll settle soon."
  },
  {
    "prompt": "Looking away",
    "incorrect": "They’ll think I’m avoiding.",
    "correct": "I’m just looking around."
  },
  {
    "prompt": "Silence around",
    "incorrect": "Everyone’s listening to me.",
    "correct": "It’s just quiet."
  },
  {
    "prompt": "Fast thoughts",
    "incorrect": "I can’t keep up with my mind.",
    "correct": "Just a busy mind."
  },
  {
    "prompt": "Stumbling words",
    "incorrect": "They’ll think I’m nervous.",
    "correct": "Everyone stumbles sometimes."
  },
  {
    "prompt": "Warm face",
    "incorrect": "I’m blushing too much.",
    "correct": "Just feeling warm."
  },
  {
    "prompt": "Deep sigh",
    "incorrect": "They think I’m stressed.",
    "correct": "Just a breath."
  },
  {
    "prompt": "Missing notes",
    "incorrect": "I’ll be lost without them.",
    "correct": "I can catch up easily."
  },
  {
    "prompt": "Quick steps",
    "incorrect": "They’ll see I’m in a rush.",
    "correct": "Just walking quickly."
  },
  {
    "prompt": "Forgot password",
    "incorrect": "I’m so forgetful.",
    "correct": "I’ll remember soon."
  },
  {
    "prompt": "Loud talking",
    "incorrect": "They’re angry with me.",
    "correct": "Just talking loudly."
  },
  {
    "prompt": "Feeling thirsty",
    "incorrect": "I must be unwell.",
    "correct": "I just need water."
  },
  {
    "prompt": "Yawning aloud",
    "incorrect": "They’ll think I’m bored.",
    "correct": "Just tired."
  },
  {
    "prompt": "Close space",
    "incorrect": "I’ll feel trapped here.",
    "correct": "It’s cozy."
  },
  {
    "prompt": "Repeating prompts",
    "incorrect": "I sound silly.",
    "correct": "It’s normal to repeat."
  },
  {
    "prompt": "Feeling jumpy",
    "incorrect": "I’m too nervous today.",
    "correct": "Just a bit on edge."
  },
  {
    "prompt": "Quiet mood",
    "incorrect": "They think I’m rude.",
    "correct": "Just being quiet."
  },
  {
    "prompt": "Not enough time",
    "incorrect": "I’m falling behind.",
    "correct": "I can pace myself."
  },
  {
    "prompt": "Lost item",
    "incorrect": "I’ll never find it.",
    "correct": "It’s around here somewhere."
  },
  {
    "prompt": "Feeling cold",
    "incorrect": "I might be sick.",
    "correct": "Just a chill."
  },
  {
    "prompt": "Looking confused",
    "incorrect": "They’ll think I’m lost.",
    "correct": "I’m figuring it out."
  },
  {
    "prompt": "Long wait",
    "incorrect": "I’m wasting time.",
    "correct": "Patience is okay."
  },
  {
    "prompt": "Odd dream",
    "incorrect": "It means something bad.",
    "correct": "Just my mind wandering."
  },
  {
    "prompt": "Busy thoughts",
    "incorrect": "I can’t keep up.",
    "correct": "Just a lot on my mind."
  },
  {
    "prompt": "Feeling warm",
    "incorrect": "I might faint.",
    "correct": "I’m just warm."
  },
  {
    "prompt": "Taking a break",
    "incorrect": "I seem lazy.",
    "correct": "Rest is important."
  },
  {
    "prompt": "Waiting alone",
    "incorrect": "I feel abandoned.",
    "correct": "Alone time is fine."
  },
  {
    "prompt": "Rushing out",
    "incorrect": "I’m in too much hurry.",
    "correct": "Just moving fast."
  },
  {
    "prompt": "Short nap",
    "incorrect": "I’ll be too tired.",
    "correct": "Just resting briefly."
  },
  {
    "prompt": "Unfamiliar task",
    "incorrect": "I’ll mess it up.",
    "correct": "I’ll learn as I go."
  },
  {
    "prompt": "Distant friend",
    "incorrect": "They’re ignoring me.",
    "correct": "They’re just busy."
  },
  {
    "prompt": "Paused music",
    "incorrect": "I feel lonely now.",
    "correct": "I can play it again."
  },
  {
    "prompt": "Forgot deadline",
    "incorrect": "I’m irresponsible.",
    "correct": "I can catch up."
  },
  {
    "prompt": "Heavy bag",
    "incorrect": "I can’t manage it.",
    "correct": "I’ll carry it slowly."
  },
  {
    "prompt": "Low energy",
    "incorrect": "Something’s wrong.",
    "correct": "Just need rest."
  },
  {
    "prompt": "Too bright",
    "incorrect": "It’s overwhelming me.",
    "correct": "I can adjust."
  },
  {
    "prompt": "Open spaces",
    "incorrect": "I feel exposed.",
    "correct": "There’s room to move."
  },
  {
    "prompt": "New task",
    "incorrect": "I’ll make mistakes.",
    "correct": "I’m learning."
  },
  {
    "prompt": "Awkward wave",
    "incorrect": "They’ll think I’m odd.",
    "correct": "Just saying hi."
  },
  {
    "prompt": "Typing slowly",
    "incorrect": "They’ll think I’m slow.",
    "correct": "I’m just careful."
  },
  {
    "prompt": "Stretching",
    "incorrect": "People think I’m tired.",
    "correct": "Just stretching."
  },
  {
    "prompt": "Bumping into someone",
    "incorrect": "They’ll think I’m clumsy.",
    "correct": "Just an accident."
  },
  {
    "prompt": "Hearing footsteps",
    "incorrect": "Someone is following me.",
    "correct": "Just someone walking nearby."
  },
  {
    "prompt": "Phone ringing",
    "incorrect": "It's bad news for sure.",
    "correct": "Maybe a friend calling to chat."
  },
  {
    "prompt": "Message notification",
    "incorrect": "Something must be wrong.",
    "correct": "A simple message, nothing urgent."
  },
  {
    "prompt": "Car honking",
    "incorrect": "They’re angry with me.",
    "correct": "Just traffic noise as usual."
  },
  {
    "prompt": "Losing keys",
    "incorrect": "I’ll never find them.",
    "correct": "They’ll turn up soon."
  },
  {
    "prompt": "Dark alley",
    "incorrect": "I might get attacked.",
    "correct": "It's just a quiet shortcut."
  },
  {
    "prompt": "Loud noise",
    "incorrect": "Something’s gone wrong.",
    "correct": "Just a random sound."
  },
  {
    "prompt": "Car speeding by",
    "incorrect": "They’re aiming for me.",
    "correct": "They’re in a hurry."
  },
  {
    "prompt": "Headache",
    "incorrect": "It could be serious.",
    "correct": "It’ll pass soon."
  },
  {
    "prompt": "Cold hands",
    "incorrect": "My circulation is failing.",
    "correct": "It's just chilly outside."
  },
  {
    "prompt": "Forgot a deadline",
    "incorrect": "I’ll get in big trouble.",
    "correct": "I’ll manage to reschedule."
  },
  {
    "prompt": "Crowded room",
    "incorrect": "They’re all judging me.",
    "correct": "Everyone’s busy with their own."
  },
  {
    "prompt": "Unfamiliar call",
    "incorrect": "It’s bad news.",
    "correct": "Probably a spam call."
  },
  {
    "prompt": "Spilled drink",
    "incorrect": "I’ll embarrass myself.",
    "correct": "I can clean it up quickly."
  },
  {
    "prompt": "Stomach ache",
    "incorrect": "It could be something serious.",
    "correct": "Maybe just something I ate."
  },
  {
    "prompt": "Running late",
    "incorrect": "I’ll miss everything.",
    "correct": "I can catch up quickly."
  },
  {
    "prompt": "Unknown dog",
    "incorrect": "It might bite me.",
    "correct": "It seems friendly."
  },
  {
    "prompt": "Big decision",
    "incorrect": "What if I choose wrong?",
    "correct": "I can think it through."
  },
  {
    "prompt": "Not feeling well",
    "incorrect": "I’m seriously ill.",
    "correct": "It’ll pass soon."
  },
  {
    "prompt": "Crowd noise",
    "incorrect": "There’s chaos around.",
    "correct": "Just people enjoying themselves."
  },
  {
    "prompt": "Lost item",
    "incorrect": "I’ll never find it.",
    "correct": "It’s around here somewhere."
  },
  {
    "prompt": "Missed call",
    "incorrect": "It was something urgent.",
    "correct": "They’ll call back if needed."
  },
  {
    "prompt": "Text delay",
    "incorrect": "They’re ignoring me.",
    "correct": "They’re probably busy."
  },
  {
    "prompt": "Door creaking",
    "incorrect": "Someone’s sneaking in.",
    "correct": "It’s just the wind."
  },
  {
    "prompt": "Forgot password",
    "incorrect": "I’m locked out forever.",
    "correct": "I can reset it easily."
  },
  {
    "prompt": "Alarm sounding",
    "incorrect": "It’s an emergency.",
    "correct": "Just a test or drill."
  },
  {
    "prompt": "Doorbell ringing",
    "incorrect": "Unexpected visitor.",
    "correct": "Probably a delivery."
  },
  {
    "prompt": "Spilled drink",
    "incorrect": "I’ll be embarrassed.",
    "correct": "I can clean it up easily."
  },
  {
    "prompt": "Forgot my ID",
    "incorrect": "I’ll be turned away.",
    "correct": "I can explain myself."
  },
  {
    "prompt": "Computer crash",
    "incorrect": "I’ve lost everything.",
    "correct": "Files are backed up."
  },
  {
    "prompt": "Feeling hot",
    "incorrect": "I might faint.",
    "correct": "It’s just warm here."
  },
  {
    "prompt": "Strange email",
    "incorrect": "It’s a scam.",
    "correct": "Just delete it safely."
  },
  {
    "prompt": "Delayed flight",
    "incorrect": "I’ll miss my event.",
    "correct": "I can rebook if needed."
  },
  {
    "prompt": "Forgot groceries",
    "incorrect": "I’ll have nothing to eat.",
    "correct": "I’ll go another day."
  },
  {
    "prompt": "Phone battery low",
    "incorrect": "I’ll be cut off.",
    "correct": "It lasts longer than I think."
  },
  {
    "prompt": "Missed turn",
    "incorrect": "I’ll get lost.",
    "correct": "I can reroute easily."
  },
  {
    "prompt": "No reply",
    "incorrect": "They’re upset with me.",
    "correct": "They’re just busy."
  },
  {
    "prompt": "New project",
    "incorrect": "I’ll mess it up.",
    "correct": "It’s a learning chance."
  },
  {
    "prompt": "Forgot lunch",
    "incorrect": "I’ll go hungry all day.",
    "correct": "I can grab a snack."
  },
  {
    "prompt": "Text misread",
    "incorrect": "They’ll misunderstand me.",
    "correct": "I can clarify it."
  },
  {
    "prompt": "Feeling cold",
    "incorrect": "Am I getting sick?",
    "correct": "It’s chilly in here."
  },
  {
    "prompt": "Overheard laugh",
    "incorrect": "They’re laughing at me.",
    "correct": "They’re enjoying a joke."
  },
  {
    "prompt": "Typing error",
    "incorrect": "I look unprofessional.",
    "correct": "It’s easy to fix."
  },
  {
    "prompt": "Forgot meeting",
    "incorrect": "I’ll seem careless.",
    "correct": "I can reschedule."
  },
  {
    "prompt": "Dog barking",
    "incorrect": "It’s aggressive.",
    "correct": "It’s protecting its home."
  },
  {
    "prompt": "Sudden silence",
    "incorrect": "Something's wrong.",
    "correct": "Just a calm moment."
  },
  {
    "prompt": "Forgot address",
    "incorrect": "I’ll miss the meeting.",
    "correct": "I can find it online."
  },
  {
    "prompt": "Phone vibration",
    "incorrect": "It’s an urgent message.",
    "correct": "Just a regular notification."
  },
  {
    "prompt": "Left lights on",
    "incorrect": "I’ll drain the battery.",
    "correct": "I’ll turn them off soon."
  },
  {
    "prompt": "Creaking floor",
    "incorrect": "Someone's inside.",
    "correct": "Old floors creak often."
  },
  {
    "prompt": "Unfamiliar face",
    "incorrect": "They might be a threat.",
    "correct": "Just someone new."
  },
  {
    "prompt": "Empty street",
    "incorrect": "I’m unsafe here.",
    "correct": "It’s peaceful and quiet."
  },
  {
    "prompt": "Low water",
    "incorrect": "We’re running out.",
    "correct": "Just refill soon."
  },
  {
    "prompt": "Cloudy sky",
    "incorrect": "It’ll storm badly.",
    "correct": "Maybe just light rain."
  },
  {
    "prompt": "New email",
    "incorrect": "It’s bad news.",
    "correct": "Probably a routine update."
  },
  {
    "prompt": "Missed bus",
    "incorrect": "I’ll be stranded here.",
    "correct": "Another one’s on the way."
  },
  {
    "prompt": "Late reply",
    "incorrect": "They’re upset with me.",
    "correct": "They were just busy."
  },
  {
    "prompt": "Heavy traffic",
    "incorrect": "I’ll be late.",
    "correct": "I’ll make up the time later."
  },
  {
    "prompt": "Forgot umbrella",
    "incorrect": "I’ll get soaked.",
    "correct": "I can find shelter if needed."
  },
  {
    "prompt": "Stranger’s gaze",
    "incorrect": "They’re judging me.",
    "correct": "Just a curious look."
  },
  {
    "prompt": "Unanswered email",
    "incorrect": "They’re avoiding me.",
    "correct": "They haven’t seen it yet."
  },
  {
    "prompt": "Voice in distance",
    "incorrect": "They’re talking about me.",
    "correct": "Just people chatting."
  },
  {
    "prompt": "Forgot charger",
    "incorrect": "I’ll run out of battery.",
    "correct": "I can borrow one."
  },
  {
    "prompt": "Empty hallway",
    "incorrect": "I’m alone and unsafe.",
    "correct": "Just some quiet space."
  },
  {
    "prompt": "Closed door",
    "incorrect": "They’re hiding from me.",
    "correct": "It’s just shut for privacy."
  },
  {
    "prompt": "Unexpected noise",
    "incorrect": "Something bad happened.",
    "correct": "Probably just random sounds."
  },
  {
    "prompt": "Distant siren",
    "incorrect": "There’s a big emergency.",
    "correct": "Emergency responders at work."
  },
  {
    "prompt": "Lost directions",
    "incorrect": "I’ll never find my way.",
    "correct": "I can check a map."
  },
  {
    "prompt": "Forgot ID card",
    "incorrect": "I’ll be turned away.",
    "correct": "It’s just a minor delay."
  },
  {
    "prompt": "Messy desk",
    "incorrect": "I seem unorganized.",
    "correct": "I’ll clean it up soon."
  },
  {
    "prompt": "Too quiet",
    "incorrect": "Something’s off.",
    "correct": "Just a calm moment."
  },
  {
    "prompt": "Weather change",
    "incorrect": "I’ll get caught in a storm.",
    "correct": "It might just drizzle."
  },
  {
    "prompt": "Phone on silent",
    "incorrect": "I’ll miss important calls.",
    "correct": "I can check it soon."
  },
  {
    "prompt": "Long line",
    "incorrect": "I’ll wait forever.",
    "correct": "Lines move fast."
  },
  {
    "prompt": "Locked door",
    "incorrect": "I’m stuck outside.",
    "correct": "I’ll find the right key."
  }
]
